import "react";

import type { StyledComponent } from "@emotion/styled";
import {
  Grid,
  type GridProps,
  StepLabel as MuiStepLabel,
  StepConnector,
  stepLabelClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "stepper";

export const classes = {
  active: `${PREFIX}-active`,
};

export const StepperConnector = styled(StepConnector)(({ theme }) => ({
  "& .MuiStepConnector-alternativeLabel": {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  "& .MuiStepConnector-line": {
    borderColor: "#eaeaf0",
    borderTopWidth: 4,
    borderRadius: 1,
  },
}));

export const IconWrapper: StyledComponent<GridProps> = styled(Grid)(() => ({
  color: "#eaeaf0",
  display: "flex",
  height: 27,
  alignItems: "center",
}));

interface ICircleProps {
  active: boolean;
  completed: boolean;
}

export const Circle = styled("div", {
  shouldForwardProp: (prop) => prop !== "active" && prop !== "completed",
})<ICircleProps>(({ active, completed, theme }) => ({
  width: 8,
  height: 8,
  borderRadius: "50%",
  backgroundColor: completed ? theme.palette.success.main : active ? theme.palette.primary.main : "currentColor",
}));

const STEP_LABEL_PREFIX = "BBJStepLabel";
export const bbjStepLabelClasses = {
  label: `${STEP_LABEL_PREFIX}-label`,
};
export const StepLabel = styled(MuiStepLabel)(({ theme }) => ({
  [`& .${stepLabelClasses.label}, & .${stepLabelClasses.alternativeLabel}, & .${stepLabelClasses.completed}`]: {
    ...theme?.typography?.body1,
  },
  [`& .${stepLabelClasses.label}`]: {
    color: theme?.palette?.text?.primary,
  },
  [`& .${stepLabelClasses.active}`]: {
    color: `${theme?.palette?.primary?.main} !important`,
    fontWeight: "600 !important",
    fontSize: "15px",
  },
  [`& .${bbjStepLabelClasses.label}`]: {
    display: "none",
    [theme.breakpoints.up("tablet")]: {
      display: "inline",
    },
  },
}));
